import React, { ReactNode } from 'react';
import { S4XMastheadProvider } from '@spotify-internal/s4x-masthead';
import { getSpotifyClientId } from '../@mrkt/features/env';
import { useLanguageSelectionContext } from '../../features/src/i18n/components/LanguageSelection';
import { useLocale, useRtl } from '../../features/src/i18n';
import { getLanguage } from './getLanguage';
import { InteractiveElement } from './InteractiveElement/index';
import { LogoSpotifyForArtists } from '@spotify-internal/encore-web';

export const MastheadProvider = ({
  children,
  contentfulEntryId,
}: {
  children: ReactNode;
  contentfulEntryId?: string;
}) => {
  const locale = useLocale();
  const rtl = useRtl();
  const { dispatch } = useLanguageSelectionContext();
  return (
    <S4XMastheadProvider
      InteractiveElement={InteractiveElement}
      clientId={getSpotifyClientId()}
      language={{
        dir: rtl ? 'rtl' : 'ltr',
        locale: getLanguage(locale),
        onClick: () => dispatch({ type: 'open' }),
        marketSelectReturnToPath: '',
        useCountryRegionPicker: false,
      }}
      contentfulEntryId={contentfulEntryId}
      loginRedirectUri="https://artists.spotify.com/c"
      logoutRedirectUri="https://artists.spotify.com/home"
      homeUrl="https://artists.spotify.com/home/?ref=logo"
      claimUrl="https://artists.spotify.com/claim"
      siteLogo={({ height }) => (
        <LogoSpotifyForArtists height={height} condensed />
      )}
    >
      {children}
    </S4XMastheadProvider>
  );
};
